export enum CruiseDetailOption {
  BOOKINGS = "BOOKINGS",
  DISCOUNTS = "DISCOUNTS",
}